<div class="cards-container" [ngClass]="{'drawer-open': isDrawerOpen()}">

  <div class="gridster-container">
    <gridster [options]="options">
      @for (card of cards(); track card.id) {
        <gridster-item [item]="card" [ngClass]="{'selected-card': selectedCards().has(card.id)}">
          <app-card
            [id]="card.id"
            [reportId]="card?.reportId ?? ''"
            [questionId]="card?.questionId ?? ''"
            [conversationId]="card?.conversationId ?? ''"
            [questionText]="card?.questionText ?? ''"
            [cardType]="card?.cardType || 'REPORT'"
            [answerId]="card?.answerId ?? ''"
            [content]="card?.content ?? ''"
            [assetId]="card?.assetId ?? ''"
            [isLoadingFreeForm]="card?.isLoadingFreeForm ?? false"
            [canvasId]="canvasId()"
            [title]="card?.title ?? ''"
            [cardData]="card?.data ?? null"
            [selectedVisualType]="card?.selectedVisualType"
            [chartConfigurations]="card?.chartConfigurations"
            [gridConfigurations]="card?.gridConfigurations"
            [isSelected]="selectedCards().has(card.id)"
            [triggerInsights]="(card.cardType === 'REPORT' && triggerInsightsForReportId() === card.reportId) || (card.cardType === 'ANSWER' && triggerInsightsForQuestionId() === card.questionId)"
            [attr.data-card-id]="card.id"
            (deleteCard)="removeCard($event)"
            (deleteFreeFormCard)="onDeleteFreeFormCard($event)"
            (answerIdUpdate)="updateCardAnswerId($event)"
            (selectionChange)="onCardSelectionChange($event)"
            (freeFormAssetCreated)="onFreeFormAssetCreated($event)"
            (freeFormSaveStateChange)="onFreeFormSaveStateChange($event)"
            (openInsightsModal)="openInsightsModal($event)"
            (triggerCanvasSave)="onTriggerCanvasSave()"
            (insightsGenerated)="onInsightsGeneratedFromCard($event)"
            (insightsError)="onInsightsError($event)"
            (titleChanged)="onCardTitleChanged($event)"
            (cardDataLoaded)="onCardDataLoaded($event)"
            (visualTypeChanged)="onVisualTypeChanged($event)"
            (chartConfigurationsChanged)="onChartConfigurationsChanged($event)"
            (gridConfigurationsChanged)="onGridConfigurationsChanged($event)">
          </app-card>
        </gridster-item>
      }
    </gridster>
  </div>

  <!-- Add Content Modal -->
  <app-add-content-modal
    [isOpen]="showAddContentModal()"
    [addedReportIds]="addedReportIds()"
    [addedQuestionIds]="addedQuestionIds()"
    [canvasId]="canvasId()"
    (closed)="closeAddContentModal()"
    (addToCanvas)="handleAddToCanvas($event)">
  </app-add-content-modal>

  <!-- Insights Modal -->
  <app-add-insights-modal
    #insightsModal
    [isOpen]="showInsightsModal()"
    [canvasId]="canvasId()"
    [canvasCards]="cards()"
    (closed)="closeInsightsModal()"
    (insightsSelected)="handleInsightsSelection($event)">
  </app-add-insights-modal>

  <!-- Confirmation Popup -->
  <app-confirmation-popup
    [isVisible]="showConfirmationPopup()"
    [message]="confirmationPopupMsg()"
    [header]="confirmationPopupHeader()"
    [confirmAction]="confirmationCallbacks.confirmAction"
    [cancelAction]="confirmationCallbacks.cancelAction">
  </app-confirmation-popup>
</div>
